import React from 'react'
import Link from "gatsby-link"
import Img from 'gatsby-image'
import PropTypes from 'prop-types'

import { Helmet } from "react-helmet"

import NewsletterPanel from '../components/NewsletterPanel'
import SocialMediaSharing from '../components/SocialMediaSharing'


const PostTemplate = ({ data, pathContext, ...rest }) => {
  const { title, subtitle, content, slug, authors, tags, mainImage, id, date, description } = data.post
  if (mainImage) {
    mainImage.sizes.aspectRatio = 2
  }

  const canonicalUrl = `https://www.consolelog.io/${slug}/`

  return (
    <section className="container">
      <Helmet>
        <title>consolelog.io => {title}</title>
        <meta name="description" content={description} />
        <meta name="og:title" content={`consolelog.io => ${title}`}/>
        <meta name="twitter:title" content={`consolelog.io => ${title}`}/>
        <meta name="og:type" content="article" />
        <meta name="og:url" content={canonicalUrl}/>
        <meta name="og:image" content={`https:${mainImage.sizes.src}`} />
        <meta name="twitter:image" content={`https:${mainImage.sizes.src}`} />
        <meta name="og:description" content={description} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <div className="columns">
        <div className="column is-8">
          <header style={{ marginBottom: '2rem' }}>
            <figure className="image">
              <Img sizes={mainImage.sizes} alt={mainImage.title} />
            </figure>
            <h1 className="title is-1 has-text-dark has-text-centered-mobile">{title}</h1>
            <div className="level">
              <div className="level-left">
                {authors.map(author => (
                  <div className="level-item" key={author.slug}>
                    <div className="level is-mobile">
                      <div className="level-item">
                        <figure className="image is-32x32">
                          <Img sizes={author.profilePicture.sizes} style={{ borderRadius: '100px' }} />
                        </figure>
                      </div>
                      <div className="level-item">
                        <span className="has-text-black has-text-weight-bold">
                          {author.name}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="level-right">
                <div className="level-item">
                  <div className="tags">
                    {tags.map((tag, idx) => (
                      <span key={idx} className="tag is-light">{tag}</span>
                    ))}
                  </div>
                </div>
                <div className="level-item">
                  <p className="has-text-weight-bold is-lowercase">{new Date(date).toLocaleDateString('en', { month: 'short', day: 'numeric', year: 'numeric' })}</p>
                </div>

              </div>
            </div>
          </header>
          <article>
            <div className="content is-medium" dangerouslySetInnerHTML={{__html: content.childMarkdownRemark.html }} />
          </article>

          <SocialMediaSharing
            url={canonicalUrl}
            title={title}
            description={description}
            hashtags={tags}
          />

          {authors.map(author => (
            <div className="box columns is-shadowless" key={author.slug} style={{ marginTop: '2rem' }}>
              <div className="column is-one-fifth">
                <figure className="image" style={{ maxWidth: '30vw', margin: 'auto' }}>
                  <Img sizes={author.profilePicture.sizes} style={{ borderRadius: '500px' }} />
                </figure>
              </div>
              <div className="column is-10 is-four-fifths">
                <p className="title is-4">{author.name}</p>
                <p className="subtitle is-6" style={{ marginBottom: '0.25rem' }}>{author.description}</p>
                <div className="level is-mobile">
                  <div className="level-left">
                    {author.socialLinks.links.map(socialLink => (
                      <div className="level-item" key={socialLink.icon}>
                        <a href={socialLink.href} className="button is-inverted is-primary">
                          <span className="icon is-medium">
                            <i className={`${socialLink.icon} fa-lg`} />
                          </span>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="column is-4">
          <NewsletterPanel />
        </div>
      </div>
    </section>
  )
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

export default PostTemplate

export const pageQuery = graphql`
  query postQuery($id: String!) {
    post: contentfulPost(id: { eq: $id }) {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
      slug
      mainImage {
        sizes(maxWidth: 800 maxHeight: 400 resizingBehavior: FILL cropFocus: FACES) {
          base64
          aspectRatio
          src
          srcSet
          sizes
        }
        description
        title
      }
      authors {
        name
        slug
        description
        socialLinks {
          links {
            href
            label
            icon
          }
        }
        profilePicture {
          sizes(maxWidth: 200 maxHeight: 200 resizingBehavior: FILL cropFocus: FACES) {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
          description
          title
        }
      }
      tags
      description
      date
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/PostTemplate.jsx